/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pxbb_V2_Reason_For_Packaging_ProcessInputs */

const vi_pxbb_v2_reason_for_packaging_process = /** @type {(inputs: Pxbb_V2_Reason_For_Packaging_ProcessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xuất sang quy trình đóng gói`)
};

/**

* @param {Pxbb_V2_Reason_For_Packaging_ProcessInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pxbb_v2_reason_for_packaging_process = /** @type {((inputs?: Pxbb_V2_Reason_For_Packaging_ProcessInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pxbb_V2_Reason_For_Packaging_ProcessInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pxbb_v2_reason_for_packaging_process(inputs)
});